import { getNeighboringCards } from '@/constants/ui/inspection/step2/step2Card/getNeighboringCards'
import { getFallingCards } from '@/constants/ui/inspection/step2/step2Card/getFallingCards'
import { getNeighboringCardNumbers } from './step2Card/getNeighboringCardNumbers'
import { getFallingCardNumbers } from './step2Card/getFallingCardNumbers'

/** step2調査タブ */
export const STEP2_INSPECTION_ITEMS = {
  neighboring: getNeighboringCards,
  falling: getFallingCards
}

/** step2調査タブ用の項番 */
export const STEP2_INSPECTION_NUMBERS = {
  neighboring: getNeighboringCardNumbers,
  falling: getFallingCardNumbers
}
